import { render, staticRenderFns } from "./logList.vue?vue&type=template&id=70ad74b4"
import script from "./logList.vue?vue&type=script&lang=js"
export * from "./logList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports